import { render, staticRenderFns } from "./AfterFirstAttraction.vue?vue&type=template&id=10d60248&scoped=true"
import script from "./AfterFirstAttraction.vue?vue&type=script&lang=js"
export * from "./AfterFirstAttraction.vue?vue&type=script&lang=js"
import style0 from "./AfterFirstAttraction.vue?vue&type=style&index=0&id=10d60248&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d60248",
  null
  
)

export default component.exports